<form class="row-inline fw-100">
  <div class="form-group fw-100" [class]="labelClass">
    <label [for]="'starting_date-' + uniq" class="form-label"
      >{{ label | translate }}
      @if (isRequired(firstDateFormControlName) || isRequired(secondDateFormControlName)) {
        <span class="color-danger"
          >*
          <span class="sr-only">{{ 'COMMON.FORMS.FIELD_REQUIRED' | translate }}</span>
        </span>
      }
    </label>
    <!-- appendTo="body": inside a scrolling drawer, a panel that changes height when the month changes
         scrolls its container, and PrimeNG closes the panel on any parent scroll (YB-2197). -->
    <div class="row-inline fw-100" style="gap: 15px">
      <span [formGroup]="formDates" [class]="class">
        <p-datepicker
          [inputId]="'starting-date-' + uniq"
          dateFormat="dd/mm/yy"
          appendTo="body"
          [showOnFocus]="showOnFocus"
          [tabindex]="tabindex ? +tabindex : null"
          [readonlyInput]="readonly"
          [formControlName]="firstDateFormControlName"
          [placeholder]="firstDatePlaceholder | translate"
          [minDate]="minDate"
          (onSelect)="fillEndFromStart()"
          (onBlur)="fillEndFromStart()"
        ></p-datepicker>
        @if (class?.includes('icon')) {
          <i class="pi icon-calendar icon color-primary"></i>
        }
      </span>
      <span [formGroup]="formDates" [class]="class">
        <p-datepicker
          [inputId]="'ending-date-' + uniq"
          dateFormat="dd/mm/yy"
          appendTo="body"
          [showOnFocus]="showOnFocus"
          [tabindex]="tabindex ? +tabindex + 1 : null"
          [readonlyInput]="readonly"
          [formControlName]="secondDateFormControlName"
          [placeholder]="secondDatePlaceholder | translate"
          [minDate]="minDate"
          (onBlur)="fillEndFromStart()"
        ></p-datepicker>
        @if (class?.includes('icon')) {
          <i class="pi icon-calendar icon color-primary"></i>
        }
      </span>
    </div>
  </div>
</form>
